var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "clearfix" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "el-form",
                { attrs: { size: "small", "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "width100", attrs: { label: "时间选择：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "mr20",
                          attrs: { type: "button", size: "small" },
                          on: {
                            change: function ($event) {
                              return _vm.selectChange(_vm.tableFrom.dateLimit)
                            },
                          },
                          model: {
                            value: _vm.tableFrom.dateLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "dateLimit", $$v)
                            },
                            expression: "tableFrom.dateLimit",
                          },
                        },
                        _vm._l(_vm.fromList.fromTxt, function (item, i) {
                          return _c(
                            "el-radio-button",
                            { key: i, attrs: { label: item.val } },
                            [_vm._v(_vm._s(item.text))]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c("el-tab-pane", {
                  attrs: { label: "已完结待申请", name: "1" },
                }),
                _vm._v(" "),
                _c("el-tab-pane", {
                  attrs: { label: "已申请待开票", name: "2" },
                }),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { label: "已开票", name: "3" } }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.activeName === "1"
              ? _c(
                  "div",
                  [
                    _c("el-card", [
                      _c(
                        "div",
                        { staticStyle: { float: "left", width: "50%" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "15px" } },
                            [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "large" } },
                                [_vm._v(" 合计金额:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "x-large",
                                  },
                                },
                                [_vm._v("￥" + _vm._s(_vm.receiptAmount))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.batchReceipt()
                                    },
                                  },
                                },
                                [_vm._v("勾选开票")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAllReceipt()
                                    },
                                  },
                                },
                                [_vm._v("全部开票")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDetails()
                                    },
                                  },
                                },
                                [_vm._v("发票抬头")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onTakerDetails()
                                    },
                                  },
                                },
                                [_vm._v("接收人")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "margin-top": "30px" } }, [
                            _c("span", [_vm._v("发票头信息:")]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.selReceiptHeader
                                    ? _vm.selReceiptHeader.companyName
                                    : "未选择开票头信息 "
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "margin-top": "10px" } }, [
                            _c("span", [_vm._v("收件人信息:")]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.selReceiptTaker
                                    ? _vm.selReceiptTaker.taker
                                    : " 未选择收件人信息 "
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { float: "left", width: "50%" } },
                        [
                          _c(
                            "el-descriptions",
                            { attrs: { title: "说明：", column: "1" } },
                            [
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "1" } },
                                [_vm._v("电子发票不支持订单商品明细")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "2" } },
                                [
                                  _vm._v(
                                    "没有1号开始完结订单自动进入当月可开票列表，因为订单完结时间不一致，每个月开票订单会实时变动"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "3" } },
                                [
                                  _vm._v(
                                    "每月开票时间 15-20 号，纸质发票一般需 3-5 工作日处理开票并寄出"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "4" } },
                                [
                                  _vm._v(
                                    "系统在线开票只针对公对公开票，开票只针对充值消费开票不针对接口费"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-card",
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.listLoading,
                                expression: "listLoading",
                              },
                            ],
                            attrs: {
                              data: _vm.tableData.data,
                              size: "small",
                              "highlight-current-row": "",
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange,
                            },
                          },
                          [
                            _c("el-table-column", {
                              key: "2",
                              attrs: { type: "selection", width: "55" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "orderNo",
                                label: "订单号",
                                "min-width": "150",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "subDistributionOrderId",
                                label: "子订单号",
                                "min-width": "100",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "createTime",
                                label: "下单时间",
                                "min-width": "100",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goodsInfo",
                                label: "商品信息",
                                "min-width": "100",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", {
                                          staticClass: "demo-image__preview",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              scope.row.goodsInfo
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                513369321
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "merName",
                                label: "商户名称",
                                "min-width": "100",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "updateTime",
                                label: "完结时间",
                                "min-width": "120",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "vipPrice",
                                label: "开票金额",
                                "min-width": "120",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "orderStatus",
                                label: "状态",
                                "min-width": "100",
                                "show-overflow-tooltip": true,
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f(
                                                  "supplierOrderStatusFilter"
                                                )(scope.row.orderStatus)
                                              )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1776993728
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm.activeName === "2"
              ? _c("div")
              : _c("div"),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName !== "1",
                    expression: "activeName !== '1'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                attrs: {
                  data: _vm.tableData.data,
                  size: "small",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "info.id",
                    label: "ID",
                    "min-width": "90",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "brokerage",
                    label: "发票头信息",
                    "min-width": "150",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "demo-image__preview" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.header
                                    ? scope.row.header.companyName
                                    : "-"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.header
                                    ? scope.row.header.creditCode
                                    : "-"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "info.applyStatus",
                    label: "状态",
                    "min-width": "80",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.info
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("receiptStatusFilter")(
                                        scope.row.info.applyStatus
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "info.totalAmount",
                    label: "开票金额",
                    "min-width": "100",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "info.applyTime",
                    label: "开票时间",
                    "min-width": "100",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "info.applyBy",
                    label: "开票人",
                    "min-width": "80",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "taker.taker",
                    label: "发票接收信息",
                    "min-width": "150",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "demo-image__preview" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.taker ? scope.row.taker.taker : "-"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.taker
                                    ? scope.row.taker.takerAddress
                                    : "-"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    "min-width": "180",
                    fixed: "right",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.info && scope.row.info.applyStatus == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCancelReceipt(
                                        scope.row.info.id
                                      )
                                    },
                                  },
                                },
                                [_vm._v("取消开票")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetailReceipt(scope.row)
                                },
                              },
                            },
                            [_vm._v("详情")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                "page-sizes": [20, 40, 60, 80],
                "page-size": _vm.tableFrom.limit,
                "current-page": _vm.tableFrom.page,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.tableData.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.pageChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发票头信息",
            visible: _vm.dialogVisible,
            id: "statement_detail_dialog",
            width: "1200px",
            "before-close": _vm.handleClose,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.receiptHeaderData,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "企业名称",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "creditCode",
                  label: "纳税人识别号",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "address",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tel",
                  label: "注册电话",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          staticClass: "demo-image__preview",
                          domProps: { innerHTML: _vm._s(scope.row.tel) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "bank",
                  label: "开户行",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "bankAccount",
                  label: "银行账号",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.removeReceiptHeader(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.selectReceiptHeader(scope.row)
                              },
                            },
                          },
                          [_vm._v("选择")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handleReceiptHeader()
                    },
                  },
                },
                [_vm._v("增加发票头信息")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "收件人信息",
            visible: _vm.dialogTakerVisible,
            id: "statement_detail_dialog",
            width: "1200px",
            "before-close": _vm.handleTakerClose,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTakerVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.receiptTakerData,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "taker",
                  label: "收件人姓名",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "takerTel",
                  label: "收件联系电话",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "takerAddress",
                  label: "收件人详细地址",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          staticClass: "demo-image__preview",
                          domProps: {
                            innerHTML: _vm._s(scope.row.takerAddress),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: "收件人邮箱",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.removeReceiptTaker(scope.row)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.selectReceiptTaker(scope.row)
                              },
                            },
                          },
                          [_vm._v("选择")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handleReceiptTaker()
                    },
                  },
                },
                [_vm._v("增加收件人信息")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogTakerVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogDetailVisible,
            size: "1200px",
            "before-close": _vm.handleDetailClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDetailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "demo-drawer_title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v("发票详情")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "demo-drawer__content" }, [
            _c(
              "div",
              { staticClass: "description" },
              [
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [_vm._v("发票头信息")]),
                _vm._v(" "),
                _c("div", { staticClass: "acea-row" }, [
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "\n            公司名称：" +
                        _vm._s(
                          _vm.receiptData.header
                            ? _vm.receiptData.header.companyName
                            : "-"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "\n            纳税人编号：" +
                        _vm._s(
                          _vm.receiptData.header
                            ? _vm.receiptData.header.creditCode
                            : "-"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "\n            公司注册地址：" +
                        _vm._s(
                          _vm.receiptData.header
                            ? _vm.receiptData.header.address
                            : "-"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "公司注册电话：" +
                        _vm._s(
                          _vm.receiptData.header
                            ? _vm.receiptData.header.tel
                            : "-"
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "开户银行：" +
                        _vm._s(
                          _vm.receiptData.header
                            ? _vm.receiptData.header.bank
                            : "-"
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "\n            开户账号：" +
                        _vm._s(
                          _vm.receiptData.header
                            ? _vm.receiptData.header.bankAccount
                            : "-"
                        ) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                [
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v("发票收件人信息"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "acea-row" }, [
                    _c("div", { staticClass: "description-term" }, [
                      _vm._v(
                        "收件人：" +
                          _vm._s(
                            _vm.receiptData.taker
                              ? _vm.receiptData.taker.taker
                              : "-"
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description-term" }, [
                      _vm._v(
                        "收件人电话：" +
                          _vm._s(
                            _vm.receiptData.taker
                              ? _vm.receiptData.taker.takerTel
                              : "-"
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description-term" }, [
                      _vm._v(
                        "\n              收件人地址：" +
                          _vm._s(
                            _vm.receiptData.taker
                              ? _vm.receiptData.taker.takerAddress
                              : "-"
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description-term" }, [
                      _vm._v(
                        "邮箱：" +
                          _vm._s(
                            _vm.receiptData.taker
                              ? _vm.receiptData.taker.email
                              : "-"
                          )
                      ),
                    ]),
                  ]),
                ],
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [_vm._v("开票信息")]),
                _vm._v(" "),
                _c("div", { staticClass: "acea-row" }, [
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "\n            发票序号：\n            " +
                        _vm._s(
                          _vm.receiptData.info ? _vm.receiptData.info.id : "-"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "开票金额：" +
                        _vm._s(
                          _vm.receiptData.info
                            ? _vm.receiptData.info.totalAmount
                            : "-"
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description-term",
                      staticStyle: { color: "red" },
                    },
                    [
                      _vm._v("\n            开票状态：\n            "),
                      _vm.receiptData.info
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("receiptStatusFilter")(
                                  _vm.receiptData.info.applyStatus
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "开票时间：" +
                        _vm._s(
                          _vm.receiptData.info
                            ? _vm.receiptData.info.applyTime
                            : "-"
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-term" }, [
                    _vm._v(
                      "开票人：" +
                        _vm._s(
                          _vm.receiptData.info
                            ? _vm.receiptData.info.applyBy
                            : "-"
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description-term",
                      staticStyle: { color: "red" },
                    },
                    [
                      _vm._v(
                        "\n            财税发票编号：" +
                          _vm._s(
                            _vm.receiptData.info
                              ? _vm.receiptData.info.receiptCode
                              : "-"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [_vm._v("开单信息")]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { size: "mini", data: _vm.receiptData.orderList },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "订单号",
                        prop: "orderNo",
                        "min-width": "120",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "子订单号",
                        prop: "subDistributionOrderId",
                        "min-width": "120",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "商品信息",
                        prop: "goodsInfo",
                        "min-width": "180",
                        "show-overflow-tooltip": true,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", {
                                staticClass: "demo-image__preview",
                                domProps: {
                                  innerHTML: _vm._s(scope.row.goodsInfo),
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "applyTime",
                        label: "申请时间",
                        "min-width": "90",
                        align: "center",
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }